import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import UITag from 'UIComponents/tag/UITag';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { removeFromCompareProducts } from '../../actions/CompareActions';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import { ProductLinePageIcons } from 'ui-addon-upgrades/_core/productPage/ProductPageIcons';
import { productSelector } from '../../selectors/ProductsSelectors';
import UIImage from 'UIComponents/image/UIImage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { ApiNameToProductTranslationKeyMap } from '../../constants/ApiNameToProductTranslationKeyMap';
import { getCompareApiNamesSelector } from '../../selectors/CompareSelectors';

const CompareTag = ({
  apiName
}) => {
  const dispatch = useDispatch();
  const compareApiNames = useSelector(getCompareApiNamesSelector, shallowEqual);

  const onCloseClick = () => {
    dispatch(removeFromCompareProducts(apiName));
    getUsageTracker().track('compareToolInteraction', {
      action: 'removed product',
      product: apiName,
      productNames: compareApiNames
    });
  };

  const {
    productLine
  } = useSelector(state => {
    return productSelector(state, {
      apiName
    });
  });
  return /*#__PURE__*/_jsxs(UITag, {
    closeable: true,
    className: "m-y-2 p-y-2",
    onCloseClick: onCloseClick,
    children: [/*#__PURE__*/_jsx(UIImage, {
      className: "display-inline m-right-2",
      src: ProductLinePageIcons[productLine],
      width: 24
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: ApiNameToProductTranslationKeyMap[apiName]
    })]
  }, apiName);
};

export default CompareTag;